import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CardSection from '@shared/components/CardSection';

interface Props {
  connected: boolean;
}

export default function OmsConnectivity({ connected }: Props) {
  return (
    <CardSection>
      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
        OMS Connectivity
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Box
          sx={{
            width: 10,
            height: 10,
            borderRadius: '50%',
            bgcolor: connected ? 'success.main' : 'error.main',
          }}
        />
        <Typography variant="body2">{connected ? 'Connected' : 'Unreachable'}</Typography>
      </Box>
    </CardSection>
  );
}
